import {
  shape,
  number,
  string,
  arrayOf,
} from 'prop-types';

export const cardType = shape({
  number: string.isRequired,
  type: string.isRequired,
  expiration_month: number.isRequired,
  expiration_year: number.isRequired,
  first_name: string.isRequired,
  last_name: string.isRequired,
  address: string,
  address_2: string,
  city: string,
  state: string,
  postal_code: string,
  country: string,
});

export const errorType = shape({
  name: string,
  statusCode: number,
  message: string,
  error: shape({
    code: number,
    code_description: string,
    error: string,
  }),
  options: shape({}),
  response: shape({}),
});

export const infoType = shape({
  created: string.isRequired,
  email: string.isRequired,
  updated: string.isRequired,
  name: string,
  organization: string,
  address_line1: string,
  address_line2: string,
  city: string,
  state_province: string,
  postal_code: string,
  country: string,
  phone_number: string,
  memo: string,
});

export const keyType = shape({
  created: string.isRequired,
  id: string.isRequired,
  updated: string.isRequired,
  name: string,
  expires: string,
  ttl: number,
  secret: string,
});

export const locationType = shape({
  hash: string.isRequired,
  key: string.isRequired,
  pathname: string.isRequired,
  search: string,
  state: shape({}),
});

export const planType = shape({
  id: string.isRequired,
  name: string.isRequired,
  period: string.isRequired,
  price: number.isRequired,
  usage: arrayOf(shape({
    id: string,
    name: string,
    pricing: shape({
      price: number,
      type: string,
    }),
    type: string,
    unit: string,
    value: number,
  })).isRequired,
  balance: number.isRequired,
  due: string.isRequired,
  period_from: string.isRequired,
  period_to: string.isRequired,
  state: string.isRequired,
});

export const recognitionType = shape({
  created: string,
  id: string.isRequired,
  media_url: string,
  status: string,
  updated: string,
});
